import ScrollTransition from './transitions/scroll-transition';
import FadeTransition from './transitions/fade-transition';
import ScrollTransition3D from './transitions/3d-scroll-transition';
export default {
  fade: FadeTransition,
  scroll: ScrollTransition,
  scroll3d: ScrollTransition3D
};